import { getPaymentSettings } from '../../selectors/currentRegistrationPath';
import getJSONValue from 'nucleus-widgets/utils/fields/getJSONValue';
import { SELECT_PAYMENT_METHOD, SET_REG_CART_PAYMENT_FIELD_VALUE } from '../regCart/actionTypes';
import { getDefaultPaymentMethodType } from './util';

export function setRegCartPaymentFieldValue(path, value) {
  return {
    type: SET_REG_CART_PAYMENT_FIELD_VALUE,
    payload: { path, value }
  };
}
export function setSelectedPaymentMethod(selectedPaymentMethod) {
  return (dispatch, getState) => {
    const defaultPaymentMethodType = getDefaultPaymentMethodType(getState(), selectedPaymentMethod);
    return dispatch({ type: SELECT_PAYMENT_METHOD,
      payload: {
        selectedPaymentMethod,
        defaultPaymentMethodType
      }
    });
  };
}

export function setCreditCardField(field, value) {
  return setRegCartPaymentFieldValue(['pricingInfo', 'creditCard', field], value);
}

export function setPaymentOfflineAdditionalDetails(paymentMethodPath, additionalDetails) {
  return setRegCartPaymentFieldValue(['pricingInfo', ...paymentMethodPath], additionalDetails);
}

export function clearInapplicableSelectedPaymentMethod() {
  return (dispatch, getState) => {
    const state = getState();
    const paymentSettings = getPaymentSettings(state);
    const selectedPaymentMethod = state.registrationForm.regCartPayment.selectedPaymentMethod;
    if (!selectedPaymentMethod) {
      return;
    }
    const selectedPaymentMethodSettings = getJSONValue(paymentSettings, selectedPaymentMethod);
    if (!selectedPaymentMethodSettings.enabled) {
      dispatch(setSelectedPaymentMethod(null));
    }
  };
}
